module.exports = __webpack_public_path__ + "img/close-gray.0a2610d6.png";